import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class contactLocations {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      direction: 'horizontal',
      effect: 'slide',
      slidesPerView: 4,
      centeredSlides: false,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.5,
          spaceBetween: 8,
        },
        // when window width is >= 480px
        768: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 3.5,
          spaceBetween: 16,
        },
        // when window width is >= 640px
        1279: {
          slidesPerView: 4,
          spaceBetween: 32,
          slidesPerGroup: 4,
        },
      },
      navigation: {
        nextEl: this.strip.find('.swiper-button-next')[0],
        prevEl: this.strip.find('.swiper-button-prev')[0],
      },
      pagination: {
        el: this.strip.find('.swiper-pagination')[0],
        type: 'bullets',
        clickable: true,
      },
    })
  }
}

export default contactLocations
